import { useQueryClient } from "@tanstack/react-query";

import useMutate from "../../../../../hooks/useMutate";
import { createWorklog, updateWorklogDetail } from "../../../../../services/apiWorklog";

export function useCreateWorklogMutation({ cardId, boardId, onSuccess }) {
  const queryClient = useQueryClient();

  return useMutate(
    createWorklog,
    ["watching", "mineCards"],
    () => {},
    () => {
      queryClient.invalidateQueries({
        queryKey: ["worklog", cardId],
      });
      queryClient.invalidateQueries({
        queryKey: ["history", String(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: ["card", cardId],
      });
      queryClient.invalidateQueries({
        queryKey: ["cards", boardId],
      });
      onSuccess?.();
    },
    () => {}
  );
}

export function useUpdateWorklogMutation({
  cardId,
  cardLogId,
  onSuccess,
}) {
  const queryClient = useQueryClient();

  return useMutate(
    updateWorklogDetail,
    [],
    () => {},
    () => {
      queryClient.invalidateQueries({
        queryKey: ["worklog", cardId],
      });
      queryClient.invalidateQueries({
        queryKey: ["history", String(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: ["card", cardId],
      });
      queryClient.invalidateQueries({
        queryKey: ["worklogDetail", cardLogId],
      });
      onSuccess?.();
    },
    () => {}
  );
}
